<template>
  <Error>
    <h1 class="context text-semibold">
      This page <span class="text-highlight">is not available</span>.
    </h1>
    <p class="sub-context text-regular">
      Sorry, you don't have permission to access this page. If you believe this is an error, please check your login status or contact support for assistance.
    </p>
  </Error>
</template>